import React from "react";
import String from "./String";
import Boolean from "./Boolean";
import Options from "./Options";
import Date from "./Date";
import Button from "./Button";
import ButtonsOptions from "./ButtonsOptions";
import Group from "./Group";

const QueryKit = {
    String,
    Boolean,
    Options,
    Date,
    Button,
    ButtonsOptions,
    Group,
};

const GetQueryChild = (child) => {
    const Body = QueryKit[child.type];
    return <Body key={child.key} prop={child} />;
};

export default GetQueryChild;
